import Button from '../../../../../ui/Button/BlockButton';
import styles from '../Disco.module.css';

interface ActionButtonsProps {
  acceptCopy: string;
  declineCopy: string;
  onAccept: () => void;
  onDecline: () => void;
}

export function ActionButtons({
  acceptCopy,
  declineCopy,
  onAccept,
  onDecline,
}: ActionButtonsProps) {
  return (
    <div className={styles.actions}>
      <Button onClick={onAccept} big className={styles.primaryBtn}>
        {acceptCopy}
      </Button>
      <Button onClick={onDecline} big outline className={styles.secondaryBtn}>
        {declineCopy}
      </Button>
    </div>
  );
}
